$(document).ready(() => {
  // initialize events
  InitJsGa4ViewItem();
  InitJsGaPurchase();
  InitJsBeginCheckout();

  // ############ view_item event ############
  function InitJsGa4ViewItem() {
    const prod = document.querySelector('.GA4_view_item');

    if (prod) {
      const item = BuildGa4ObjectViewItem(prod.dataset)

      if (Object.keys(item).length) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'view_item',
          ecommerce: {
            currency: 'USD',
            value: parseFloat(item.price || 0),
            items: [item]
          }
        });
      }
    }
  }

  function BuildGa4ObjectViewItem(dataset) {
    return {
      item_name: (dataset.item_name) || '',
      item_id: dataset.item_id || '',
      price: parseFloat(parseFloat(dataset.item_price).toFixed(2) || 0),
      item_brand: dataset.item_brand || '',
      item_category: dataset.item_category || '',
      item_category2: dataset.item_category2 || '',
      item_category3: dataset.item_category3 || '',
      item_category4: dataset.item_category4 || '',
      item_category5: dataset.item_category5 || '',
      item_variant: dataset.item_variant || '',
      quantity: parseInt(dataset.quantity || 1)
    }
  }

  // ############ add_to_cart event - PDP and Search Results ############
  document.addEventListener('added-to-cart', event => {
    const productList = [];
    const item = event.detail.cart.currentItem;
    const currency = event.detail.cart.currency.code || 'USD';
    const total = parseFloat(event.detail.cart.currentItem.Ga4Value);
    const qty = event.detail.cart.currentItem.Ga4Quantity
    const prod = document.querySelector(`.GA4_add_to_cart[data-item_id='${item.atccNumber}']`);

    if (prod) {
      const ga_product = BuildGa4ObjectAddToCart(prod.dataset, qty);
      productList.push(ga_product);
    }

    if (productList) {
      const formattedProductList = productList.map((item, index) => ({
        ...item,
        index
      }));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency,
          value: parseFloat(total.toFixed(2) || 0),
          items: formattedProductList
        }
      });
    }
  });

  document.addEventListener('added-to-cart-lgc', event => {
    const productList = [];
    const item = event.detail.cart.currentItem;
    const currency = event.detail.cart.currency.code || 'USD';
    const total = parseFloat(event.detail.cart.currentItem.Ga4Value);
    const qty = event.detail.cart.currentItem.Ga4Quantity
    const prod = document.querySelector(`.GA4_add_to_cart[data-item_id='${item.atccNumber}']`);

    if (prod) {
      const ga_product = BuildGa4ObjectAddToCart(prod.dataset, qty);
      productList.push(ga_product);
    }

    if (productList) {
      const formattedProductList = productList.map((item, index) => ({
        ...item,
        index
      }));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency,
          value: parseFloat(total.toFixed(2) || 0),
          items: formattedProductList
        }
      });
    }
  });

  // ########## add_to_cart event - required products ###########
  document.addEventListener('requiredAddedToCart', event => {
    const productList = [];
    const item = event.detail.cart.currentItem;
    const currency = event.detail.cart.currency.code || 'USD';
    const total = parseFloat(event.detail.cart.currentItem.Ga4Value);
    const qty = event.detail.cart.currentItem.Ga4Quantity
    const prod = document.querySelector(`.GA4_add_to_cart[data-item_id='${item.atccNumber}']`);
    const ga_product = BuildGa4ObjectAddToCart(prod.dataset, qty);
    productList.push(ga_product);

    if (productList) {
      const formattedProductList = productList.map((item, index) => ({
        ...item,
        index
      }));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency,
          value: parseFloat(total.toFixed(2) || 0),
          items: formattedProductList
        }
      });
    }
  });

  // ########## add_to_cart event - list detail and compare modal products ###########
  document.addEventListener('customAddedToCart', event => {
    const product = event.detail.cart.currentItem;
    const currency = event.detail.cart.currency.code || 'USD';
    const total = parseFloat(event.detail.cart.currentItem.Ga4Value);

    if (product) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency,
          value: parseFloat(total.toFixed(2) || 0),
          items: [{
            item_name: removeHtmlTags(product.Ga4Name) || '',
            item_id: product.Ga4Id || '',
            price: parseFloat(parseFloat(product.price).toFixed(2) || 0),
            item_brand: product.Ga4Brand || '',
            item_category: product.Ga4Category || '',
            item_category2: product.Ga4Category2 || '',
            item_category3: product.Ga4Category3 || '',
            item_category4: product.Ga4Category4 || '',
            item_category5: product.Ga4Category5 || '',
            item_variant: product.Ga4Variant || '',
            item_list_name: '',
            item_list_id: '',
            index: 0,
            quantity: product.Ga4Quantity
          }]
        }
      });
    }
  });

  // ########### add_to_cart event - quick order ################
  document.addEventListener('quickOrderAddedToCart', event => {
    const quickOrderPage = document.querySelector('.GA4_add-to-cart-quick-order');

    if (quickOrderPage) {
      const itens = document.querySelectorAll('.GA4_add-to-cart-item');
      const productList = [];
      let total = 0;

      itens.forEach((item, index) => {
        total = total + parseFloat(item.dataset.item_price.replace('$', '').replace(/,/g, '')) * parseInt(item.dataset.item_qty)
        productList.push({
          item_name: (item.dataset.item_name) || '',
          item_id: item.dataset.item_id || '',
          price: parseFloat(item.dataset.item_price.replace('$', '').replace(/,/g, '') || 0),
          item_brand: item.dataset.item_brand || '',
          item_category: item.dataset.item_category || '',
          item_category2: item.dataset.item_category2 || '',
          item_category3: item.dataset.item_category3 || '',
          item_variant: item.dataset.item_variant || '',
          item_list_name: 'Quick Order',
          item_list_id: 'quick_order',
          index,
          quantity: parseInt(item.dataset.item_qty || 1)
        })
      });

      if (productList) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'USD',
            value: parseFloat(total.toFixed(2)),
            items: productList
          }
        });
      }

    }
  });

  // ############ add_to_cart event - order detail - add all to cart ############
  const orderDetailBtnReorderAll = document.querySelector('.order-detail-btn-reorder-all');
  if (orderDetailBtnReorderAll) {
    const productList = [];
    let total = 0;

    orderDetailBtnReorderAll.addEventListener('click', () => {
      $('.GA4_add_to_cart').each(function(index, element) {
        const qty = $(this).attr('data-item_quantity');
        const ga_product = BuildGa4ObjectAddToCart(element.dataset, qty);
        productList.push(ga_product);
        const price = parseFloat(element.dataset.item_price || 0)
        total = parseFloat(total + price * parseInt(qty));
      });

      if (productList) {
        const formattedProductList = productList.map((item, index) => ({
          ...item,
          index
        }));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'USD',
            value: parseFloat(total.toFixed(2) || 0),
            items: formattedProductList
          }
        });
      }
    });
  }

  // ############ add_to_cart event - order detail - add item to cart ############
  const buttons = document.querySelectorAll('.order-detail-btn-reorder-item');
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const parentElement = this.parentNode;
      const parentData = parentElement.dataset;

      const productList = [];
      let total = 0;
      const qty = $(this).closest('.GA4-item').find('.item-qty').html().split('Qty: ')[1];

      const ga_product = BuildGa4ObjectAddToCart(parentData, qty);
      productList.push(ga_product);
      const price = parseFloat(parentData.item_price || 0)
      total = Number(total + price);

      if (productList) {
        const formattedProductList = productList.map((item, index) => ({
          ...item,
          index
        }));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'USD',
            value: parseFloat(total.toFixed(2) || 0),
            items: formattedProductList
          }
        });
      }
    });
  });

  function BuildGa4ObjectAddToCart(dataset, qty) {
    return {
      item_name: removeHtmlTags(dataset.item_name) || '',
      item_id: dataset.item_id || '',
      price: parseFloat(parseFloat(dataset.item_price).toFixed(2) || 0),
      item_brand: dataset.item_brand || '',
      item_category: dataset.item_category || '',
      item_category2: dataset.item_category2 || '',
      item_category3: dataset.item_category3 || '',
      item_category4: dataset.item_category4 || '',
      item_category5: dataset.item_category5 || '',
      item_variant: dataset.item_variant || '',
      item_list_name: dataset.item_list_name || '',
      item_list_id: dataset.item_list_id || '',
      index: parseInt(dataset.item_index) || 0,
      quantity: parseInt(qty || 1)
    }
  }

  // ############ purchase event ############
  function InitJsGaPurchase() {
    const productList = [];
    const purchase = document.querySelector('.GA4_purchase');

    if (purchase) {
      const itens = document.querySelectorAll('.GA4_purchase_item');

      itens.forEach(item => {
        const product = BuildGa4ObjectPurchase(item.dataset);
        productList.push(product);
      });

      if (productList) {
        const formattedProductList = productList.map((item, index) => ({
          ...item,
          index
        }));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            currency: 'USD',
            value: parseFloat(purchase.dataset.item_total || 0),
            tax: parseFloat(purchase.dataset.item_total_tax || 0),
            shipping: parseFloat(purchase.dataset.item_total_shipping || 0),
            transaction_id: purchase.dataset.item_transaction_id,
            items: formattedProductList
          }
        });
      }
    }
  }

  function BuildGa4ObjectPurchase(dataset) {
    return {
      item_name: removeHtmlTags(dataset.item_name) || '',
      item_id: dataset.item_id || '',
      price: parseFloat(parseFloat(dataset.item_price).toFixed(2) || 0),
      item_brand: dataset.item_brand || '',
      item_category: dataset.item_category || '',
      item_category2: dataset.item_category2 || '',
      item_category3: dataset.item_category3 || '',
      item_category4: dataset.item_category4 || '',
      item_category5: dataset.item_category5 || '',
      item_variant: dataset.item_variant || '',
      index: parseInt(dataset.item_index) || 0,
      quantity: parseInt(dataset.item_quantity || 1),
      item_coupon: dataset.item_coupon || ''
    }
  }

  // ############ begin_checkout event ############
  function InitJsBeginCheckout() {
    const shippingInformation = document.querySelector('.shipping-information__container');

    if (shippingInformation) {
      setTimeout(() => {
        const productList = [];
        const itens = document.querySelectorAll('.GA4_begin_checkout');
        const total = document.querySelector('.order-summary-details-item-value').textContent.replace('$', '').replace(/,/g, '');

        itens.forEach(item => {
          const product = BuildGa4ObjectBeginCheckout(item.dataset);
          productList.push(product);
        });

        if (productList) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
              currency: 'USD',
              value: parseFloat(total || 0),
              items: productList
            }
          });
        }
      }, 1000)

    }
  }

  function BuildGa4ObjectBeginCheckout(dataset) {
    return {
      item_name: removeHtmlTags(dataset.item_name) || '',
      item_id: dataset.item_id || '',
      price: parseFloat(parseFloat(dataset.item_price).toFixed(2) || 0),
      item_brand: dataset.item_brand || '',
      item_category: dataset.item_category || '',
      item_category2: dataset.item_category2 || '',
      item_category3: dataset.item_category3 || '',
      item_category4: dataset.item_category4 || '',
      item_category5: dataset.item_category5 || '',
      item_variant: dataset.item_variant || '',
      item_list_name: dataset.item_list_name || '',
      item_list_id: dataset.item_list_id || '',
      index: (parseInt(dataset.item_index) - 1) || 0,
      quantity: parseInt(dataset.item_quantity || 1)
    }
  }
});

function removeHtmlTags(str) {
  return str.replace(/<\/?[^>]+(>|$)/g, '');
}
